<template>
  <footer class="m-grid__item	m-footer">
    <div class="m-container m-container--fluid m-container--full-height m-page__container">
      <div class="m-stack m-stack--tablet m-stack--ver m-stack--desktop">
        <div class="m-stack__item m-stack__item--left m-stack__item--middle m-stack__item--last">
          <span class="m-footer__copyright">
            {{ (new Date()).getFullYear() }} &copy; {{ $t('app.ts') }}
          </span>
        </div>

        <div class="m-stack__item m-stack__item--right m-stack__item--middle m-stack__item--first">
          <ul class="m-footer__nav m-nav m-nav--inline m--pull-right">
            <li class="m-nav__item">
              <router-link
                :to="{ name: 'Advertise'}"
                class="m-nav__link"
                active-class="active"
              >
                <span class="m-nav__link-text">
                  {{ $t('advertise.AdvertiseProperty') }}
                  <span
                    v-if="showBadgeProperty"
                    class="m-badge m-badge--danger"
                  >!</span>
                </span>
              </router-link>
            </li>
            <li class="m-nav__item">
              <router-link
                :to="{ name: 'AdvertiseDir'}"
                class="m-nav__link"
                active-class="active"
              >
                <span class="m-nav__link-text">
                  {{ $t('advertise.AdvertiseDirectoryv2') }}
                  <span
                    v-if="showBadgeDirectory"
                    class="m-badge m-badge--danger"
                  >!</span>
                </span>
              </router-link>
            </li>
            <li class="m-nav__item">
              <router-link
                :to="{ name: 'Support'}"
                class="m-nav__link"
                active-class="active"
              >
                <router-link
                  tag="span"
                  :to="{ name: 'Support'}"
                  active-class="active"
                  class="m-nav__link-text"
                >
                  {{ $t('common.support') }}
                </router-link>
              </router-link>
            </li>
            <li
              v-if="false"
              class="m-nav__item"
            >
              <router-link
                :to="{ name: 'FAQ'}"
                class="m-nav__link"
                active-class="active"
              >
                <span class="m-nav__link-text">{{ $t('common.faq') }}</span>
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>

export default {
    data() {
        return {
        };
    },
    computed: {
        showBadgeProperty() {
            return false;
        },
        showBadgeDirectory() {
            return false;
        },
    },
    mounted() {
    },
    methods: {
    },
};
</script>
